import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getTotalProductsApprovedForDiscount = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop/products/discount/approval-count',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
    });
}